import React from 'react';
import ResultView from '../Components/Result/ResultView';
import { useParams, useNavigate } from 'react-router-dom'; // useNavigate instead of redirect

const ResultPage = () => {

    const { projectId, imageId, resultId } = useParams();
    const navigate = useNavigate(); // useNavigate hook
    const [show, setShow] = React.useState(true);

    const handleClose = () => {
        console.log('handleClose');
        setShow(false);
        navigate(`/projects/${projectId}/images/${imageId}/`); // use navigate for redirection
    }

    if(!show) return null;

    return (
        <ResultView
            projectId={projectId || ''}
            imageId={imageId || ''}
            resultId={resultId || ''}
            onClose={handleClose} />
    );
}

export default ResultPage;
